import React from 'react';
import { Route } from 'react-router';

import { GuardedRoute } from 'app/dealer/shared/components/GuardedRoute/GuardedRoute';
import { authorities } from 'app/dealer/constants';
import { fetchAuthorities } from 'app/dealer/shared/modules/authorities/actions';

const getComponent = (loc, cb) => {
  return import('./Dashboard/ConnectedDashboard').then(c => {
    return cb(null, c.ConnectedDashboard);
  });
};
const { MANAGE_MY_NETWORK, READ_MY_NETWORK } = authorities;
const requiredAuthorities = [MANAGE_MY_NETWORK, READ_MY_NETWORK];
const refreshAuthorities = ({ dispatch }) => {
  return (nextState, replace, next) => {
    return dispatch(fetchAuthorities())
      .then(() => next())
      .catch(() => next());
  };
};

export const getDashboardRoutes = store => {
  const { getState } = store;

  return (
    <Route name="dashboard" onEnter={refreshAuthorities(store)}>
      <GuardedRoute
        getComponent={getComponent}
        getState={getState}
        path="/dealer/dashboard"
        redirectTo="/dealer/logout"
        requiredAuthorities={requiredAuthorities}
      />
    </Route>
  );
};
